/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A trigger for a process
 */
export interface ProcessTrigger { 
    id?: string;
    parameters?: object;
    type?: ProcessTrigger.TypeEnum;
}
export namespace ProcessTrigger {
    export type TypeEnum = 'variable.change';
    export const TypeEnum = {
        VariableChange: 'variable.change' as TypeEnum
    };
}


